/* eslint-disable */
jQuery('.OpenModal').on('click', (e) => {
  jQuery('.Modal').toggleClass('Modal-show');

  const cf7Form = document.querySelector('.wpcf7');
  const submit = cf7Form.querySelector('.wpcf7-submit');

  if (cf7Form && submit.getAttribute('destino')) {
    submit.setAttribute('destino', e.target.getAttribute('pdf-id'))
  }
});

jQuery('.Modal-close, .Modal-overlay').on('click', () => {
  jQuery('.Modal').removeClass('Modal-show');
});


jQuery('.OpenModalSocial').on('click', () => {
  jQuery('.ModalSocial').toggleClass('ModalSocial-show');
});


jQuery('.ModalSocial-close, .ModalSocial-overlay').on('click', () => {
  jQuery('.ModalSocial').removeClass('ModalSocial-show');
});


jQuery('.BlockVideo-image').on('click', function() {
  var element = jQuery(this);
  var modal = jQuery('.Modal');
  var videoSRC = element.attr('data-videoSRC');
  var iframe = '<iframe src="https://www.youtube.com/embed/'+videoSRC+'" frameborder="0" allowfullscreen></iframe>';
  modal.find('.Modal-content').append(iframe);
  modal.addClass('Modal-show');

  jQuery('.BlockVideo .Modal-close').on('click', function() {
    jQuery('.BlockVideo iframe').remove();
  });
});
